'use client';
import React, { useState } from 'react';

import { Snackbar, Button } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Link from 'next/link';

const PreviewAlert = ({ previewEnabled }: { previewEnabled: boolean }) => {
  const [open, setOpen] = useState(previewEnabled);

  const action = (
    <>
      <Link prefetch={false} href='/api/preview/disable'>
        <Button color='inherit' size='small'>
          EXIT
        </Button>
      </Link>
      <IconButton
        size='small'
        aria-label='close'
        color='inherit'
        onClick={() => setOpen(false)}
      >
        <CloseIcon fontSize='small' />
      </IconButton>
    </>
  );

  return (
    <Snackbar
      className='previewAlert'
      //   style={{ alignSelf: "flex-end" }}
      open={open}
      message='You are in preview mode'
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      action={action}
    />
  );
};

export default PreviewAlert;
